import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
// primereact components
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import { confirmDialog } from "primereact/confirmdialog";
import { Skeleton } from "primereact/skeleton";
// Components
import ModalEditCel from "../Modal/ModalEditCel";
// Services
import { useQuery } from "react-query";
import { getWhitelistQuick } from "../../../../../services/QuickRegister/getWhitelistQuick";
import { deleteWhitelistQuick } from "../../../../../services/QuickRegister/deleteWhitelistQuick";

const List = ({ control, page, rows, onPageChange }) => {
  const [search, setSearch] = useState("");
  const [modalEditVisible, setModalEditVisible] = useState(false);
  const [editTelefones, setEditTelefones] = useState([]);
  const [editTelefoneAtual, setEditTelefoneAtual] = useState("");
  const [editRowId, setEditRowId] = useState(null);

  const {
    data: whitelistData = [],
    isLoading: isWhitelistLoading,
    refetch,
  } = useQuery("getWhitelistQuick", getWhitelistQuick, {
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
  });

  useEffect(() => {
    refetch();
    // eslint-disable-next-line
  }, []);

  const filteredData = search
    ? (whitelistData || []).filter((item) => {
        const nome = (item.name || "").toLowerCase();
        let telefones = Array.isArray(item.contacts)
          ? item.contacts.map((c) => c.number).join(", ")
          : "";
        const telefone = (telefones || "").toLowerCase();
        return (
          nome.includes(search.toLowerCase()) ||
          telefone.includes(search.toLowerCase())
        );
      })
    : whitelistData || [];

  const paginatedData = filteredData.slice(page, page + rows);

  const handleDelete = async (id) => {
    const user = (whitelistData || []).find((item) => item.id === id);
    confirmDialog({
      message: `Você tem certeza que deseja excluir o ${
        user?.name || ""
      } da lista de permissões?`,
      header: "Confirmação de Exclusão",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",

      accept: async () => {
        const toastId = toast.loading("Excluindo contato...");
        try {
          await deleteWhitelistQuick(id);
          toast.update(toastId, {
            render: "Contato excluído com sucesso!",
            type: "success",
            isLoading: false,
            autoClose: 2000,
          });
          refetch();
        } catch (error) {
          console.error("Erro ao excluir contato:", error);
          toast.update(toastId, {
            render: "Erro ao excluir contato. Tente novamente mais tarde.",
            type: "error",
            isLoading: false,
            autoClose: 4000,
          });
        }
      },
      reject: () => {},
    });
  };

  const nomeBodyTemplate = (rowData) => {
    return (
      <span
        style={{
          fontWeight: 600,
          fontSize: 16,
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        {rowData.name}
      </span>
    );
  };

  const telefoneBodyTemplate = (rowData) => {
    let telefones = Array.isArray(rowData.contacts)
      ? rowData.contacts.map((c) => c.number)
      : [];
    const exibicao =
      telefones.length > 0 ? telefones.join(", ") : "Sem telefone";
    return (
      <span
        style={{
          fontSize: 13,
          fontWeight: 400,
          userSelect: "none",
        }}
      >
        {exibicao}
      </span>
    );
  };

  const actionBodyTemplate = (rowData) => (
    <div style={{ display: "flex", gap: 8 }}>
      <Button
        icon="pi pi-trash"
        className="p-button-danger"
        style={{ padding: "4px 8px", fontSize: 13 }}
        onClick={() => handleDelete(rowData.id)}
        tooltip="Excluir"
        type="button"
      />
    </div>
  );

  const handleEditTelefone = async (novosTelefones) => {};

  return (
    <div className="w-100 d-flex flex-column ">
      {isWhitelistLoading ? (
        <div className="d-flex justify-content-end mb-3 w-100">
          <div style={{ maxWidth: 320, width: "100%" }}>
            <Skeleton width="100%" height="2.5rem" className="mb-2" />
          </div>
        </div>
      ) : (
        whitelistData &&
        whitelistData.length > 0 && (
          <div className="d-flex justify-content-end mb-3 w-100">
            <div style={{ maxWidth: 320, width: "100%" }}>
              <IconField className="align-items-end justify-content-end w-100">
                <InputIcon className="pi pi-search" />
                <input
                  type="text"
                  className="p-inputtext p-component w-100"
                  placeholder="Pesquisar por nome ou telefone"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </IconField>
            </div>
          </div>
        )
      )}
      <DataTable
        value={isWhitelistLoading ? Array(5).fill({}) : paginatedData}
        className="w-100"
        paginator={false}
        responsiveLayout="scroll"
        style={{ minWidth: 400 }}
        emptyMessage={
          isWhitelistLoading ? "Carregando..." : "Nenhum contato encontrado."
        }
      >
        <Column
          field="name"
          header="Nome"
          body={
            isWhitelistLoading
              ? () => <Skeleton width="80%" height="1.5rem" />
              : nomeBodyTemplate
          }
        />
        <Column
          field="contacts"
          header="Telefone"
          body={
            isWhitelistLoading
              ? () => <Skeleton width="60%" height="1.2rem" />
              : telefoneBodyTemplate
          }
        />
        <Column
          header="Ação"
          body={
            isWhitelistLoading
              ? () => <Skeleton width="40px" height="1.5rem" />
              : actionBodyTemplate
          }
          style={{ width: 100, textAlign: "center" }}
        />
      </DataTable>
      {!isWhitelistLoading && (
        <Paginator
          first={page}
          rows={rows}
          totalRecords={filteredData.length}
          onPageChange={onPageChange}
          rowsPerPageOptions={[5, 10, 20]}
          style={{ marginTop: 16 }}
        />
      )}
      <ModalEditCel
        visible={modalEditVisible}
        onHide={() => setModalEditVisible(false)}
        telefones={editTelefones}
        telefoneAtual={editTelefoneAtual}
        onConfirm={handleEditTelefone}
        userId={editRowId}
        setUserId={setEditRowId}
        setTelefoneAtual={setEditTelefoneAtual}
        usuario={(whitelistData || []).find((item) => item.id === editRowId)}
      />
    </div>
  );
};

export default List;
